import React from 'react';
import { Share as ShareIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useColors } from 'legacyfrontend/hooks/useColors';
import { useToast } from 'legacyfrontend/hooks/useToast';
import { useTranslation } from 'react-i18next';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';
import ErrorSnackbar from 'legacyfrontend/components/ErrorSnackbar';

const ShareButton = ({ 
  url, 
  title = 'Compartir',
  size = 'medium',
  className = '',
  onShare = () => {}
}) => {
  const { background } = useColors();
  const { toastState, showSuccess, hideToast } = useToast();
  const { t } = useTranslation('layout');

  const handleShareClick = async () => {
    if (!isClient) return;
    
    try {
      const urlToCopy = url || window.location.href;
      await navigator.clipboard.writeText(urlToCopy);
      showSuccess(t('translations:link_copied'), 3000);
      onShare(urlToCopy);
    } catch (err) {
      console.error('Error copying to clipboard:', err);
      // Fallback para navegadores que no soportan clipboard API
      const urlToCopy = url || window.location.href;
      const textArea = document.createElement('textarea');
      textArea.value = urlToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      showSuccess(t('translations:link_copied'), 3000);
      onShare(urlToCopy);
    }
  };

  return (
    <>
      <IconButton
        onClick={handleShareClick}
        size={size}
        className={className}
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: background,
          color: 'white',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: background,
            transform: 'translateY(-2px)',
          }
        }}
      >
        <ShareIcon />
      </IconButton>
      
      <ErrorSnackbar
        open={toastState.open}
        message={toastState.message}
        severity={toastState.severity}
        onClose={hideToast}
      />
    </>
  );
};

export default ShareButton;
